// extracted by mini-css-extract-plugin
export default {"dialog":"CetsDialog_dialog__x1sZX","buttons":"CetsDialog_buttons__o7Ia7","button_wrapper":"CetsDialog_button_wrapper__MsZNX","message":"CetsDialog_message__2za4R"};